import CompanionMaterialItem from '@/models/CompanionMaterialItem';
import ICompanionMaterialConversionHandler from './ICompanionMaterialConversionHandler';

class DoNothingCompanionMaterialConversionHandler implements ICompanionMaterialConversionHandler {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  execute(companionMaterialItem: CompanionMaterialItem): Map<string, unknown> {
    return new Map<string, unknown>();
  }
}

export default DoNothingCompanionMaterialConversionHandler;
